import {getApp, getApps, initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDa4xFVLb-uqy4rri4eNN_EmONEFEI2WPk",
    authDomain: "os-pms-fe2b6.firebaseapp.com",
    projectId: "os-pms-fe2b6",
    storageBucket: "os-pms-fe2b6.firebasestorage.app",
    messagingSenderId: "276185676389",
    appId: "1:276185676389:web:05aa99b0b0759ddd67a48c",
    measurementId: "G-FZ96ZXF2N3"
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
// const db = getFirestore();


const socialAuth = getAuth(app);

export {socialAuth};
